<div class="st-page">
  <div class="sd-head">
    <div>
      <h1 class="sd-title">{{ 'myClasses' | translate }}</h1>
    </div>
  </div>

  <div class="sb-search-box">
    <i class="ri-search-line"></i>
    <input type="text" [ngModel]="searchString" (ngModelChange)="onSearchInput($event)"
      placeholder="{{ 'searchClassesPlaceholder' | translate }}" />
  </div>

  <div class="sd-grid" *ngIf="loading">
    <div class="sd-card sd-skeleton-card" *ngFor="let s of skeletonPlaceholders">
      <div class="sd-skeleton-header"></div>
      <div class="sd-card-body">
        <div class="sd-students-row">
          <div class="sd-skeleton-icon"></div>
          <div class="sd-skeleton-line sd-skeleton-line-medium"></div>
        </div>
        <div class="sd-teacher-row">
          <div class="sd-skeleton-icon sd-skeleton-icon-round"></div>
          <div class="sd-teacher-text">
            <div class="sd-skeleton-line sd-skeleton-line-short"></div>
            <div class="sd-skeleton-line sd-skeleton-line-medium"></div>
          </div>
          <div class="sd-skeleton-chevron"></div>
        </div>
      </div>
    </div>
  </div>

  <div class="st-empty-state" *ngIf="!loading && loadError">
    <i class="ri-error-warning-line"></i> {{ 'couldntLoadYourClassesPleaseTryAgain' | translate }}
  </div>

  <div class="st-empty-state" *ngIf="!loading && !loadError && visibleClasses.length === 0">
    <i class="ri-layout-grid-line"></i> {{ 'noClassesAssignedYet' | translate }}
  </div>

  <div class="sd-grid" *ngIf="!loading && !loadError && visibleClasses.length">
    <div class="sd-card" *ngFor="let cls of visibleClasses" (click)="openClass(cls)">
      <div class="sd-card-header" [ngClass]="'sd-header-' + cls.color">
        <div class="sd-card-class">{{ cls.className }} &ndash; {{ cls.section }}</div>
        <div class="sd-grade-watermark">{{ gradeNumber(cls) }}</div>
      </div>

      <div class="sd-card-body">
        <div class="sd-students-row">
          <div class="sd-students-icon" [ngClass]="'sd-tint-' + cls.color"><i class="ri-group-line"></i></div>
          <div>
            <span class="sd-students-value">{{ cls.totalStudents }}</span>
            <span class="st-list-sub">{{ 'studentsEnrolled' | translate }}</span>
          </div>
        </div>

        <div class="sd-teacher-row">
          <div class="st-avatar sd-teacher-avatar" [ngClass]="'sd-tint-solid-' + cls.color">
            <img *ngIf="cls.classTeacherImage" [src]="cls.classTeacherImage" alt="" />
            <ng-container *ngIf="!cls.classTeacherImage">{{ cls.classTeacherInitials }}</ng-container>
          </div>
          <div class="sd-teacher-text">
            <span class="sd-teacher-label">{{ 'classTeacher' | translate }}</span>
            <span class="sd-teacher-name">{{ cls.classTeacherName || ('noClassTeacher' | translate) }}</span>
          </div>
          <button class="sd-chevron-btn" [ngClass]="'sd-tint-' + cls.color" (click)="openClass(cls); $event.stopPropagation()">
            <i class="ri-arrow-right-s-line"></i>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="sd-load-more" *ngIf="!loading && !loadError && maxPageNumber > pageNumber">
    <button class="st-btn st-btn-secondary" [disabled]="loadingMore" (click)="loadMore()">
      {{ loadingMore ? ('loading' | translate) : ('loadMore' | translate) }}
    </button>
  </div>
</div>
